// Route.jsx
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom' // استبدال useParams بـ useSearchParams
import { useMethods } from '@shared/hooks/methods'
import { useDialogs } from '@shared/hooks/dialogs'

import axios from '@shared/utils/axios'

export default function EstimationPreviewRoute() {
    const [searchParams] = useSearchParams()
    const estimationId = searchParams.get('estimation')

    const { showMessage } = useMethods()
    const { show } = useDialogs()

    useEffect(() => {
        if (!estimationId) return
        let isMounted = true
        ;(async function() {
            showMessage({
                text: 'جارٍ التحميل...',
                loading: true
            })
            try {
                const request = await axios.get(`estimations/${estimationId}/`)
                if (isMounted) {
                    showMessage(null)
                    show('estimation', request.data)
                }
            } catch {
                if (isMounted) {
                    showMessage({ text: 'حدث خطأ اثناء جلب المقايسة.' })
                }
            }
        })()

        return () => {
            isMounted = false
        }
    }, [estimationId])

    return null
}